import { render } from "./ChevronClose.vue?vue&type=template&id=da7fa7ea"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ChevronClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da7fa7ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da7fa7ea', __exports__)) {
    api.reload('da7fa7ea', __exports__)
  }
  
  module.hot.accept("./ChevronClose.vue?vue&type=template&id=da7fa7ea", () => {
    api.rerender('da7fa7ea', render)
  })

}


export default __exports__